// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Templates = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Templates = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Templates = _exports.Templates = function Templates(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M3.75 3.125C3.40625 3.125 3.125 3.40625 3.125 3.75V16.25C3.125 16.5938 3.40625 16.875 3.75 16.875H12.5V13.75C12.5 13.0586 13.0586 12.5 13.75 12.5H16.875V3.75C16.875 3.40625 16.5938 3.125 16.25 3.125H3.75ZM12.5 18.75H3.75C2.37109 18.75 1.25 17.6289 1.25 16.25V3.75C1.25 2.37109 2.37109 1.25 3.75 1.25H16.25C17.6289 1.25 18.75 2.37109 18.75 3.75V12.5V12.7148C18.75 13.3789 18.4883 14.0156 18.0195 14.4844L14.4844 18.0195C14.0156 18.4883 13.3789 18.75 12.7148 18.75H12.5Z",
      fill: "currentColor"
    }));
  };
});
